import { relations } from "drizzle-orm";
import { boolean, pgTable, serial, text, timestamp } from "drizzle-orm/pg-core";

export const workspace = pgTable("workspace", {
	id: serial("id").primaryKey(),
	name: text("name").notNull(),
	slug: text("slug").notNull().unique(),
	description: text("description"),
	createdAt: timestamp("created_at").notNull().defaultNow(),
	updatedAt: timestamp("updated_at").notNull().defaultNow(),
});

export const workspaceMembers = pgTable("workspace_members", {
	id: serial("id").primaryKey(),
	workspaceId: serial("workspace_id")
		.notNull()
		.references(() => workspace.id),
	userId: text("user_id").notNull(),
	role: text("role").notNull().default("member"), // owner, admin, member, guest, deactivated
	joinedAt: timestamp("joined_at").notNull().defaultNow(),
	isActive: boolean("is_active").default(true).notNull(),
});

export const workspaceRelations = relations(workspace, ({ many }) => ({
	members: many(workspaceMembers),
}));

export const workspaceMembersRelations = relations(
	workspaceMembers,
	({ one }) => ({
		workspace: one(workspace, {
			fields: [workspaceMembers.workspaceId],
			references: [workspace.id],
		}),
	}),
);
